import {
    CheckCircleOutline,
    Delete,
    DoDisturbOn,
    Download,
    FilterAlt,
    Visibility,
} from "@mui/icons-material";
import {
    Alert,
    Avatar,
    Button,
    Card,
    Divider,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Table,
    TableBody,
    TableCell,
    TablePagination,
    TableRow,
    Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useParams } from "react-router-dom";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    TableCellStyle,
    TableContainerStyled,
    TableHeadStyled,
    TableRowStyled,
} from "../../Layouts/TableStyle";
import {
    GetAllSolarContractsMethod,
    resetSolar,
} from "../../Redux/SolarContracts/SolarSlice";
import CardInformation from "../../Layouts/CardInfo/CardInformation";
import { PDF_URL_SIGNED } from "../../API/Api";

const AllSolarContracts = () => {
    const { user_id } = useParams();
    const { lead_id } = useParams();
    const { solar_contracts, isLodaing } = useSelector(
        (state) => state.contract
    );

    const AllContracts = solar_contracts?.data?.contracts?.data || [];
    const ContractsCost = solar_contracts?.data?.cost || [];
    const ContractsPag = solar_contracts?.data?.contracts || [];
    // Pagination Page

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        const callSearchAction = async () => {
            await dispatch(
                GetAllSolarContractsMethod({
                    user_id: user_id,
                    lead_id: lead_id,
                    paginate: rowsPerPage,
                    page: newPage + 1,
                })
            );
            await dispatch(resetSolar());
        };
        callSearchAction();
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
        const callSearchAction = async () => {
            await dispatch(
                GetAllSolarContractsMethod({
                    user_id: user_id,
                    lead_id: lead_id,
                    paginate: event.target.value,
                })
            );
            await dispatch(resetSolar());
        };
        callSearchAction();
    };

    const dispatch = useDispatch();

    useEffect(() => {
        const GetAllSolarContracts = async () => {
            if (user_id || lead_id) {
                await dispatch(
                    GetAllSolarContractsMethod({
                        user_id: user_id,
                        lead_id: lead_id,
                    })
                );
            } else {
                await dispatch(GetAllSolarContractsMethod());
            }
            await dispatch(resetSolar());
        };
        GetAllSolarContracts();
    }, [dispatch, lead_id, user_id]);

    const handelDownloadPdfFile = (path) => {
        const link = document.createElement("a");

        // link.download = `${path}`;
        link.target = "_blank";
        link.href = `${PDF_URL_SIGNED}/${path}`;
        link.click();
    };

    return (
        <>
            {isLodaing && <LoadingAnimation />}
            {!isLodaing && (
                <>
                    {user_id && user_id > 0 && (
                        <Container>
                            <CardInformation
                                data={AllContracts[0]?.opportunity?.user}
                                ContractsCost={ContractsCost}
                                type="user"
                            />
                        </Container>
                    )}
                    {lead_id && lead_id > 0 && (
                        <Container>
                            <CardInformation
                                data={AllContracts[0]?.opportunity?.lead}
                                ContractsCost={ContractsCost}
                                type="lead"
                            />
                        </Container>
                    )}
                    <TableContainerStyled>
                        <Table aria-label="simple table">
                            <TableHeadStyled>
                                <TableRow>
                                    <TableCell>#</TableCell>
                                    {/* {!user_id && ( */}
                                    <TableCell> User Name</TableCell>
                                    {/* )} */}
                                    {/* {!user_id && ( */}
                                    <TableCell> User Email </TableCell>
                                    {/* )} */}
                                    {/* {!lead_id && ( */}
                                    <>
                                        <TableCell> Lead Name</TableCell>
                                        <TableCell> Lead Email</TableCell>
                                        <TableCell> Lead Phone</TableCell>
                                    </>
                                    {/* )} */}
                                    <TableCell> System Size </TableCell>
                                    <TableCell> Cost </TableCell>
                                    <TableCell> Finance Co </TableCell>
                                    <TableCell> Signed </TableCell>
                                </TableRow>
                            </TableHeadStyled>

                            <TableBody>
                                {AllContracts?.map((key, index) => (
                                    <TableRowStyled key={key?.id}>
                                        <TableCellStyle>
                                            {rowsPerPage * page + index + 1}
                                        </TableCellStyle>
                                        {/* {!user_id && ( */}
                                        <TableCellStyle>
                                            <Link
                                                to={`/dashboard/solar-contracts/user=${key?.opportunity?.user?.id}`}
                                            >
                                                <Typography color="primary">
                                                    {
                                                        key?.opportunity?.user
                                                            ?.name
                                                    }
                                                </Typography>
                                            </Link>
                                        </TableCellStyle>
                                        {/* )} */}
                                        {/* {!user_id && ( */}
                                        <TableCellStyle>
                                            {key?.opportunity?.user?.email}
                                        </TableCellStyle>
                                        {/* )} */}
                                        {/* {!lead_id && ( */}
                                        <>
                                            <TableCellStyle>
                                                <Link
                                                    to={`/dashboard/solar-contracts/lead=${key?.opportunity?.lead?.id}`}
                                                >
                                                    <Typography color="primary">
                                                        {key?.opportunity?.lead
                                                            ?.first_name +
                                                            " " +
                                                            key?.opportunity
                                                                ?.lead
                                                                ?.last_name}
                                                    </Typography>
                                                </Link>
                                            </TableCellStyle>
                                            <TableCellStyle>
                                                {key?.opportunity?.lead?.email}
                                            </TableCellStyle>
                                            <TableCellStyle>
                                                {key?.opportunity?.lead?.phone}
                                            </TableCellStyle>
                                        </>
                                        {/* )} */}
                                        <TableCellStyle>
                                            {key?.opportunity?.system_size}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key.cost}
                                        </TableCellStyle>
                                        <TableCellStyle align="center">
                                            {key.opportunity
                                                ?.financial_institution === null
                                                ? "Cach"
                                                : key.opportunity
                                                      ?.financial_institution}
                                        </TableCellStyle>
                                        <TableCellStyle>
                                            {key?.eversign_document?.url ? (
                                                <IconButton
                                                    onClick={(e) =>
                                                        handelDownloadPdfFile(
                                                            key
                                                                ?.eversign_document
                                                                ?.url
                                                        )
                                                    }
                                                    sx={{ color: "primary" }}
                                                >
                                                    <Visibility />
                                                </IconButton>
                                            ) : (
                                                "Not Signed"
                                            )}
                                            {/* <IconButton>
                                                <Link
                                                    to={`/dashboard/solar-contracts/show=${key.id}`}
                                                >
                                                    <Visibility color="primary" />
                                                </Link>
                                            </IconButton> */}
                                        </TableCellStyle>
                                    </TableRowStyled>
                                ))}
                            </TableBody>

                            <TableHeadStyled>
                                <TableRow>
                                    {ContractsPag.total >= 20 && (
                                        <TablePagination
                                            rowsPerPageOptions={[
                                                20,
                                                50,
                                                100,
                                                { label: "All", value: -1 },
                                            ]}
                                            colSpan={12}
                                            count={ContractsPag.total}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={
                                                handleChangeRowsPerPage
                                            }
                                        />
                                    )}
                                </TableRow>
                            </TableHeadStyled>
                        </Table>

                        {ContractsPag?.total < 1 && (
                            <Alert icon={false} severity="error">
                                <Typography
                                    variant="h6"
                                    className="MuiTypography-alignCenter"
                                >
                                    There are no items, please try again
                                </Typography>
                            </Alert>
                        )}
                    </TableContainerStyled>
                </>
            )}
        </>
    );
};

export default AllSolarContracts;
